import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SupportTicketSource } from '@nx-c4g/c4g-models';
import { TranslateModule } from '@ngx-translate/core';
import { SupportTicketHubComponent } from './support-ticket-hub.component';

export interface SupportTicketHubDialogData {
  source: SupportTicketSource;
}

@Component({
  selector: 'nx-c4g-support-ticket-hub-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    SupportTicketHubComponent,
  ],
  templateUrl: './support-ticket-hub-dialog.component.html',
  styleUrls: ['./support-ticket-hub-dialog.component.scss'],
})
export class SupportTicketHubDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<SupportTicketHubDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: SupportTicketHubDialogData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
